import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { 
  Home, 
  Users, 
  Briefcase, 
  Calendar, 
  Menu,
  MapPin,
  Target,
  FileText,
  Map,
  BarChart2,
  Settings,
  ShieldAlert,
  X
} from 'lucide-react';

export default function MobileNav({ user }) {
  const location = useLocation();
  const [showMore, setShowMore] = useState(false);

  const mainItems = [
    { name: 'หน้าหลัก', path: '/', icon: <Home size={22} /> },
    { name: 'Existing Customer', path: '/customers', icon: <Users size={22} /> },
    { name: 'งาน', path: '/tasks', icon: <Briefcase size={22} /> },
    { name: 'ปฏิทิน', path: '/calendar', icon: <Calendar size={22} /> },
  ];

  const moreItems = [
    { name: 'แผนที่ลูกค้า', path: '/customer-map', icon: <MapPin size={20} /> },
    { name: 'Marketing Lead', path: '/opportunities', icon: <Target size={20} /> },
    { name: 'ใบเสนอราคา', path: '/quotations', icon: <FileText size={20} /> },
    { name: 'รายการโปรด', path: '/visits', icon: <Map size={20} /> },
  ];

  const adminItems = [
    { name: 'แดชบอร์ดผู้บริหาร', path: '/exec-dashboard', icon: <BarChart2 size={20} /> },
    { name: 'จัดการเขตการขาย', path: '/admin', icon: <ShieldAlert size={20} /> },
    { name: 'ตั้งค่า', path: '/settings', icon: <Settings size={20} /> },
  ];

  const isAdmin = user?.role === 'super_admin';

  return (
    <>
      <nav className="mobile-nav">
        {mainItems.map((item) => {
          const isActive = location.pathname === item.path || (item.path !== '/' && location.pathname.startsWith(item.path));
          return (
            <Link 
              key={item.path} 
              to={item.path} 
              className={`mobile-nav-item ${isActive ? 'active' : ''}`}
            >
              <div className="mobile-nav-icon">{item.icon}</div>
              <span className="mobile-nav-text">{item.name}</span>
            </Link>
          );
        })}
        <button 
          className={`mobile-nav-item ${showMore ? 'active' : ''}`} 
          onClick={() => setShowMore(true)}
          style={{ background: 'none', border: 'none', padding: 0 }}
        >
          <div className="mobile-nav-icon"><Menu size={22} /></div>
          <span className="mobile-nav-text">อื่นๆ</span>
        </button>
      </nav>

      {/* More Drawer */}
      {showMore && (
        <div className="mobile-drawer-overlay" onClick={() => setShowMore(false)}>
          <div className="mobile-drawer" onClick={(e) => e.stopPropagation()}>
            <div className="mobile-drawer-header">
              <h3 style={{ margin: 0, color: '#374151', fontSize: '1.1rem' }}>เมนูอื่นๆ</h3>
              <button onClick={() => setShowMore(false)} style={{ background: 'none', border: 'none', cursor: 'pointer', color: '#6b7280' }}>
                <X size={24} />
              </button>
            </div>
            
            <div className="mobile-drawer-content">
              {moreItems.map(item => (
                <Link 
                  key={item.path} 
                  to={item.path} 
                  className={`drawer-item ${location.pathname === item.path ? 'active' : ''}`}
                  onClick={() => setShowMore(false)}
                >
                  {item.icon}
                  {item.name}
                </Link>
              ))}

              {isAdmin && (
                <>
                  <div style={{ margin: '1.5rem 0 0.5rem 1rem', fontSize: '0.75rem', fontWeight: 700, color: '#9ca3af', textTransform: 'uppercase' }}>
                    ผู้ดูแลระบบ
                  </div>
                  {adminItems.map(item => (
                    <Link 
                      key={item.path} 
                      to={item.path} 
                      className={`drawer-item ${location.pathname === item.path ? 'active' : ''}`}
                      onClick={() => setShowMore(false)}
                    >
                      {item.icon}
                      {item.name}
                    </Link>
                  ))}
                </>
              )}
            </div>
            
            <div style={{ padding: '1rem', textAlign: 'center', fontSize: '0.75rem', color: '#9ca3af', borderTop: '1px solid #e5e7eb' }}>
              © 2024 Toyota Material Handling
            </div>
          </div>
        </div>
      )}
    </>
  );
}
